import type { ReactNode } from 'react';
import { SWRConfig } from 'swr';
import { createAdminSwrConfig } from './adminSwrConfig.js';

export interface AdminSWRProviderProps {
  readonly children: ReactNode;
}

export function AdminSWRProvider({ children }: AdminSWRProviderProps): JSX.Element {
  return (
    <SWRConfig value={createAdminSwrConfig(true)}>
      {children}
    </SWRConfig>
  );
}
